<template>
  <div class="login">
    <div class="login__inner">
      <Sidebar />
      <div class="login__rs">
        <div class="login__logo-intro--above">
          <img src="@/assets/cia_logo_white.svg" alt="CIA" class="mb-5">
        </div>
        <RecivePassword />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './../components/Login/Sidebar.vue';
import RecivePassword from './../components/Login/RecivePassword.vue';

export default {
  name: 'recive-password',
  components: {
    Sidebar,
    RecivePassword,
  },
};
</script>
